import React from "react";
import { CAPABILITIES } from "@/constants/capabilities";

/**
 * Renders the TACO capabilities list with icons and bold headings.
 * Used in the help panel's intro section below the TACO definition.
 */
const HelpCapabilities: React.FC = () => (
  <div className="space-y-2">
    {CAPABILITIES.map((cap, index) => (
      <div key={index} className="flex items-start gap-2 py-1">
        <span className="text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0">
          <cap.icon className="h-4 w-4" />
        </span>
        <div className="flex flex-col">
          <span className="text-sm font-semibold text-foreground">
            {cap.title}
          </span>
          <span className="text-sm text-muted-foreground leading-relaxed">
            {cap.description}
          </span>
        </div>
      </div>
    ))}
  </div>
);

export default HelpCapabilities;
